import { DNI_PARAM as DNI_PARAM_KEY } from '../../config/settings/constant'

export const MOP_TABLE_HEADER = ['Rubro', 'Especialidad', 'Categoría', 'Estado']
export const MINVU_TABLE_HEADER = ['Rubro', 'Especialidad', 'Categoría', 'Estado', 'Fecha caducidad']
export const MOP_HEADING_INFORMATION = [
  {
    label: 'Estado',
    value: 'providerState'
  },
  {
    label: 'Vigencia desde',
    value: 'startDate'
  },
  {
    label: 'Vigencia hasta',
    value: 'expirationDate'
  }
]
export const MINVU_HEADING_INFORMATION = [
  {
    label: 'Estado',
    value: 'statusDescription'
  },
  {
    label: 'Fecha de caducidad',
    value: 'expirationDate'
  }
]
export const DNI_PARAM = DNI_PARAM_KEY.replace(':', '')
